import React from 'react';
import { Link } from 'react-router-dom';
import { EmptyState as KitEmptyState } from '../../sectepe-ui/index';
import { Icon, IconName } from '../icons';

export interface EmptyStateAction {
  label: string;
  /** Ziel-Route (rendert einen Link) ... */
  to?: string;
  /** ... oder Klick-Handler (rendert einen Button). */
  onClick?: () => void;
}

export interface EmptyStateProps {
  icon?: IconName;
  title: string;
  description?: React.ReactNode;
  action?: EmptyStateAction;
  secondaryAction?: EmptyStateAction;
  /** Weniger Innenabstand, z. B. innerhalb einer Karte. */
  compact?: boolean;
  children?: React.ReactNode;
}

const ActionButton: React.FC<{ action: EmptyStateAction; primary: boolean }> = ({ action, primary }) => {
  const cls = `btn ${primary ? 'btn-primary' : 'btn-secondary'}`;
  if (action.to) {
    return <Link to={action.to} className={cls}>{action.label}</Link>;
  }
  return <button type="button" className={cls} onClick={action.onClick}>{action.label}</button>;
};

/**
 * Leerzustand mit Erklaerung und -- wichtig -- dem naechsten sinnvollen
 * Schritt als Knopf. Duenner Wrapper um `EmptyState` aus @sectepe/ui
 * (API der App bleibt).
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon = 'info', title, description, action, secondaryAction, compact, children,
}) => (
  <KitEmptyState
    className={`empty-state ui-empty-state${compact ? ' ui-empty-state--compact' : ''}`}
    icon={<Icon name={icon} size={compact ? 18 : 22} />}
    title={title}
    description={description}
    actions={
      action || secondaryAction ? (
        <>
          {action && <ActionButton action={action} primary />}
          {secondaryAction && <ActionButton action={secondaryAction} primary={false} />}
        </>
      ) : undefined
    }
  >
    {children}
  </KitEmptyState>
);

export default EmptyState;
